import { motion, useScroll, useTransform, useReducedMotion, useMotionTemplate } from "framer-motion";

// One evolving ambient light layer across the whole journey (scroll-linked, GPU-safe)
export const AmbientLight = () => {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const x = useTransform(scrollYProgress, [0, 0.25, 0.5, 0.75, 1], ["78%", "18%", "82%", "24%", "50%"]);
  const y = useTransform(scrollYProgress, [0, 1], ["12%", "88%"]);
  const hue = useTransform(scrollYProgress, [0, 0.33, 0.66, 1], [265, 190, 330, 45]);
  const bg = useMotionTemplate`radial-gradient(46% 38% at ${x} ${y}, hsla(${hue}, 90%, 60%, 0.075), transparent 70%)`;
  if (reduce) return null;
  return (
    <motion.div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none"
      style={{ background: bg, zIndex: 3 }}
    />
  );
};
